import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.touchScreen = window.matchMedia('(hover: none)');
  }

  reveal(event) {
    if (!this.touchScreen.matches || this.element.classList.contains('is-open')) {
      return;
    }

    event.preventDefault();
    this.element.classList.add('is-open');
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.element.classList.remove('is-open');
    }
  }
}
